import { cloneDeep } from 'lodash-es';
import { set } from 'date-fns';
import { isoStringRegex } from '@shared/constants/regex.const';

export const validDate = (value: string | Date): boolean => {
    const regexPassed = isoStringRegex.test(value instanceof Date ? value.toISOString() : value);
    if (!regexPassed) {
        return false;
    }
    const testDate = new Date(value);
    const validTime = !isNaN(testDate.getTime());
    const validISOConversion = testDate.toISOString() === (value instanceof Date ? value.toISOString() : value);
    return validTime && validISOConversion;
};

export const assignTime = (target: Date, source: Date): Date => {
    const res = cloneDeep(target);
    return set(res, {
        hours: source.getHours(),
        minutes: source.getMinutes(),
        seconds: source.getSeconds(),
    });
};

export const isDateInstance = (value: unknown): value is Date => {
    return value instanceof Date;
};
